import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import de from './locales/de.json';
import en from './locales/en.json';

// Get saved language from localStorage or use default
const savedLanguage = localStorage.getItem('language') || 'browser';

// Determine actual language to use
let initialLanguage = 'de';
if (savedLanguage === 'browser') {
  const browserLang = navigator.language?.split('-')[0] || 'de';
  initialLanguage = ['de', 'en'].includes(browserLang) ? browserLang : 'de';
} else {
  initialLanguage = savedLanguage;
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    lng: initialLanguage,
    fallbackLng: 'de',
    interpolation: {
      escapeValue: false,
    },
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng: string) => {
  // Don't save the actual language, keep 'browser' if that was the selection
  const savedSetting = localStorage.getItem('language');
  if (savedSetting !== 'browser') {
    localStorage.setItem('language', lng);
  }
});

export default i18n;
